
export const degreesLoading = ({store}) => store.degreeReducer.loading;

export const degreesError = ({store}) => store.degreeReducer.error;

export const degreesData = ({store}) => store.degreeReducer.data;